export const shapesWithAlts = {
  Circle: false,
  ArrowCommon: true,
  ArrowThin: true,
  ArrowFull: true,
  RoundedThinRectangle: true,
  ArrowWithoutTail: true,
  Oval: false,
  Quarter: true,
  CurvedArrow: true,
  Triangle: true,
  Trapeze1: true,
  Trapeze2: true,
  Trapeze3: true,
  LongTriangle: true,
  Rectangle: false,
  RoundedRectangle: false,
};

export const isShapeWithAlts = (shape) => {
  return shapesWithAlts[shape];
};
